import React from "react";

/**
 * EnlargedPhotoModal component for displaying a user's photo in full screen
 *
 * @param {Object} props
 * @param {Object|null} props.user - User object with photoURL and name (null to hide modal)
 * @param {Function} props.onClose - Handler when modal is closed
 */
export function EnlargedPhotoModal({ user, onClose }) {
  if (!user) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center"
      onClick={onClose}
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors"
      >
        <svg
          className="w-8 h-8"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
      <div
        className="max-w-4xl max-h-[90vh] flex flex-col items-center"
        onClick={(e) => e.stopPropagation()}
      >
        {user.photoURL ? (
          <img
            src={user.photoURL}
            alt={user.name || "User"}
            className="max-w-full max-h-[80vh] object-contain rounded-lg"
          />
        ) : (
          <div className="w-64 h-64 bg-gradient-to-br from-primary to-primaryDark flex items-center justify-center rounded-lg">
            <span className="text-white text-6xl font-bold">
              {(user.name || "?").charAt(0).toUpperCase()}
            </span>
          </div>
        )}
        <p className="text-white text-xl mt-4 font-semibold">
          {user.name || "Unnamed User"}
        </p>
      </div>
    </div>
  );
}
